/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    const mobile = window.matchMedia('(max-width: 767px)');
    const root = document.documentElement;
    let scrollPosition = 0;

    function closeMenu() {
        if (!navigation.classList.contains('is-open')) return;

        navigation.classList.remove('is-open');
        root.classList.remove('gh-navigation-open');
        root.style.removeProperty('--gh-navigation-scroll-top');
        window.scrollTo({top: scrollPosition, behavior: 'instant'});
    }

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            if (!mobile.matches) return;

            scrollPosition = window.scrollY;
            root.style.setProperty('--gh-navigation-scroll-top', `${-scrollPosition}px`);
            root.classList.add('gh-navigation-open');
            navigation.classList.add('is-open');
        } else {
            closeMenu();
        }
    });

    mobile.addEventListener('change', function () {
        if (!mobile.matches) closeMenu();
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Group imported quote code lines into copyable code blocks */
(function () {
    const blockquotes = document.querySelectorAll('.gh-content blockquote:not([data-rtm-code-processed])');

    if (!blockquotes.length) return;

    function isCodeNode(node) {
        return node.nodeType === Node.ELEMENT_NODE && node.tagName === 'CODE';
    }

    function isBreakNode(node) {
        return node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR';
    }

    function isWhitespaceNode(node) {
        return node.nodeType === Node.TEXT_NODE && !node.textContent.trim();
    }

    function codeRunFrom(node) {
        const sequence = [];
        let current = node;

        while (current && (isCodeNode(current) || isBreakNode(current) || isWhitespaceNode(current))) {
            sequence.push(current);
            current = current.nextSibling;
        }

        let lastCodeIndex = -1;
        sequence.forEach(function (item, index) {
            if (isCodeNode(item)) {
                lastCodeIndex = index;
            }
        });

        return lastCodeIndex === -1 ? null : {
            textNodes: sequence.slice(0, lastCodeIndex + 1),
            removeNodes: sequence
        };
    }

    function breakRunBefore(node) {
        const sequence = [];
        let current = node.previousSibling;

        while (current && (isBreakNode(current) || isWhitespaceNode(current))) {
            sequence.unshift(current);
            current = current.previousSibling;
        }

        return sequence;
    }

    function textFromCodeRun(nodes) {
        return nodes.map(function (node) {
            if (isBreakNode(node)) {
                return '\n';
            }
            if (isCodeNode(node)) {
                return node.textContent.replace(/\u00a0/g, ' ');
            }
            return '';
        }).join('').replace(/\n+$/, '');
    }

    function copyText(text) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        }

        return new Promise(function (resolve, reject) {
            const input = document.createElement('textarea');
            input.value = text;
            input.setAttribute('readonly', '');
            input.style.position = 'fixed';
            input.style.top = '-9999px';
            document.body.appendChild(input);
            input.select();

            try {
                document.execCommand('copy') ? resolve() : reject();
            } catch (error) {
                reject(error);
            } finally {
                document.body.removeChild(input);
            }
        });
    }

    function setCopyTooltip(button, text) {
        button.dataset.tooltip = text;
        button.setAttribute('aria-label', text === 'Copy' ? 'Copy code' : text);
        window.clearTimeout(button.rtmCopyTimer);
        button.rtmCopyTimer = window.setTimeout(function () {
            button.dataset.tooltip = 'Copy';
            button.setAttribute('aria-label', 'Copy code');
        }, 1600);
    }

    function codeBlockFor(text) {
        const wrapper = document.createElement('div');
        const pre = document.createElement('pre');
        const code = document.createElement('code');
        const button = document.createElement('button');

        wrapper.className = 'rtm-quote-code';
        code.textContent = text;
        pre.appendChild(code);

        button.className = 'rtm-quote-code-copy';
        button.type = 'button';
        button.dataset.tooltip = 'Copy';
        button.setAttribute('aria-label', 'Copy code');
        button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect width="14" height="14" x="8" y="8" rx="2" ry="2"></rect><path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"></path></svg>';
        button.addEventListener('click', function () {
            copyText(text)
                .then(function () {
                    setCopyTooltip(button, 'Copied');
                })
                .catch(function () {
                    setCopyTooltip(button, 'Error');
                });
        });

        wrapper.appendChild(pre);
        wrapper.appendChild(button);

        return wrapper;
    }

    blockquotes.forEach(function (blockquote) {
        let node = blockquote.firstChild;

        while (node) {
            if (!isCodeNode(node)) {
                node = node.nextSibling;
                continue;
            }

            const run = codeRunFrom(node);
            const text = run ? textFromCodeRun(run.textNodes) : '';

            if (!text.trim()) {
                node = node.nextSibling;
                continue;
            }

            const block = codeBlockFor(text);
            const leadingBreaks = breakRunBefore(node);
            blockquote.insertBefore(block, node);
            leadingBreaks.forEach(function (item) {
                item.parentNode.removeChild(item);
            });
            run.removeNodes.forEach(function (item) {
                item.parentNode.removeChild(item);
            });
            node = block.nextSibling;
        }

        blockquote.setAttribute('data-rtm-code-processed', 'true');
    });
})();
